module.exports = __webpack_public_path__ + "static/media/user.inactive.8fd9dc04.svg";